import { render } from "./PublicHome.vue?vue&type=template&id=12948d2f&scoped=true"
import script from "./PublicHome.vue?vue&type=script&lang=js"
export * from "./PublicHome.vue?vue&type=script&lang=js"

import "./PublicHome.vue?vue&type=style&index=0&id=12948d2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12948d2f"]])

export default __exports__